// Back To Top Function
import { scrollToTopOptions } from './types/global';

const scrollToTop = (ele: Element, opts: scrollToTopOptions) => {
    const top = ele;
    const duration = (opts && opts.duration) || 400;

    const easeOutQuad = (t: number, b: number, c: number, d: number) => {
        return -c * (t /= d) * (t - 2) + b;
    };

    top.addEventListener('click', (e) => {
        // Shortcut
        const docElement = document.documentElement;

        // Get position-top and timer at begin
        const yBegin = (window.scrollY || docElement.scrollTop) - (docElement.clientTop || 0);
        const yEnd = 0;
        const tBegin = +new Date();
        let n = 0;
        let yCur;
        let yEasing;
        let timeCur;

        // Iteration
        const step = () => {
            n++;
            timeCur = (+new Date() - tBegin) / duration;
            yCur = (1 - timeCur) * yBegin;
            yEasing = easeOutQuad(+new Date() - tBegin, 0, 1, duration);
            let yCur2 = (1 - yEasing) * yBegin;

            // Make "yCur" always >= 0
            if (yCur < 0) yCur = 0;

            if (0 < yCur2 && yCur2 < 1) yCur2 = 0;

            // Window ScrollTo
            window.scrollTo(0, yCur2);

            // Request Animation Frame -> make loop
            if (yCur > yEnd) {
                requestAnimationFrame(step);
            }
        };

        step();

        // Don't scrolltop with href="#"
        e.preventDefault();
    });
};

/**
 * CREATE NEW PLUGIN BY:
 *  new ScrollTop(element, options)
 */
if (window.TCMS && typeof window.TCMS === 'object') {
    window.TCMS.scrollToTop = scrollToTop;
}

/**
 * Back to Top Button
 * */

const backToTop = (element: Element, isFade = true) => {
    if (element) {
        const pageContainerHeaderElem = document.querySelector('#c24-page-container-header');

        // @ts-ignore
        window.fireOnVisible(
            pageContainerHeaderElem,
            async(_elem, entry) => {
                if (isFade) {
                    if (entry.isIntersecting) {
                        element.classList.remove('fadeIn');
                    } else {
                        element.classList.add('fadeIn');
                    }
                }
            },
            {
                custom: true,
                loop: true,
                threshold: 0
            }
        );

        // Binds the click event
        window.TCMS.scrollToTop?.(element, {}); // Fallback für Safari IE und Edge, die alle kein scrollTo Smooth beherrschen
    }
};

const jumpToTopElem = document.querySelector('.c24-footer-jumptotop');
const backToTopElem = document.querySelector('.js24BackToTop');

if (jumpToTopElem) {
    backToTop(jumpToTopElem, false);
}

if (backToTopElem) {
    backToTop(backToTopElem, true);
}
